<div class="modal-header">
    <h2 class="modal-title">{{'adminUsers.filterPopup.title' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeHandler(false)">
    </button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-6">
            <label class="label-input">
                {{'adminUsers.filterPopup.fromDate' | translate}}
            </label>
            <kendo-datepicker HJSuppress
                [(ngModel)]="startDate" 
                #startDateInput
                (ngModelChange)="startDateChangeHandler()"
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"    
                (click)="!startDateInput.isOpen ? startDateInput.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                >
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
        <div class="col-md-6">
            <label class="label-input">
                {{'adminUsers.filterPopup.toDate' | translate}}
            </label>
            <kendo-datepicker HJSuppress
                [(ngModel)]="endDate" 
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                #endDateInput 
                (click)="!endDateInput.isOpen ? endDateInput.toggle() : null"
                [disabledDates]="disabledPastDates"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                >
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="resetHandler()">
        <i class="app-icon icon icon-reload icon-lg me-2"></i> 
        {{'adminUsers.filterPopup.reset' | translate}}
    </button>
    <button class="btn primary-btn" (click)="applyHandler()">
        {{'adminUsers.filterPopup.apply' | translate}}
    </button>
</div>